import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getStrategiesList } from "../service";

export const useStrategiesList = (initialParams = {}) => {
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery({
      queryKey: ["strategiesList", initialParams],
      queryFn: async ({ pageParam = 1 }) => {
        const params = {
          ...initialParams,
          page: pageParam,
          size: initialParams.size || 10,
        };

        const response = await getStrategiesList(params);
        return {
          data: response.data || [],
          currentPage: response.page || 1,
          totalPages: response.total_pages || 1,
          totalCount: response.total_count || 0,
        };
      },
      getNextPageParam: (lastPage) => {
        const currentPage = Number(lastPage.currentPage);
        const totalPages = Number(lastPage.totalPages);
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
    });

  const allStrategies = data?.pages?.flatMap((page) => page.data) || [];
  const totalCount = data?.pages?.[0]?.totalCount ?? 0;
  return {
    strategies: allStrategies,
    totalCount,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  };
};
